module.exports = __webpack_public_path__ + "img/MatriculasAbertas-800x350px.877a05fd.png";